<template>
    <div>
        <Backer />

        <div class="fm-container">
            <div><h4>Product Warehouse Inventory</h4></div>
            <div class="search-header">
                <b-form>
                    <b-row>
                        <b-col>
                            <span>Search By</span>
                            <b-form-select
                              id="search_by"
                              v-model="search_by"
                              :options="search_bys"
                              required
                              style="width: 200px; display: inline-block;"
                            ></b-form-select>

                            <span v-if="search_by === 'sku'">
                                <b-input type="text" 
                                style="width: 200px; display: inline-block;"
                                v-model="search_values.sku"></b-input>
                            </span>

                            <span v-else-if="search_by === 'product_category'">
                                <b-form-select
                                  v-model="search_values.product_category"
                                  :options="categories"
                                  required
                                  style="width: 300px; min-width: 300px; max-width: 400px; display: inline-block; vertical-align: top;"
                                ></b-form-select>
                            </span>

                            <span v-else-if="search_by === 'product_name'">
                                <b-input type="text" 
                                style="width: 200px; display: inline-block;"
                                v-model="search_values.product_name"></b-input>
                            </span>

                            <span v-else-if="search_by === 'location'">
                                <b-form-select
                                  v-model="search_values.location"
                                  :options="locations"
                                  required
                                  value-field="id"
                                  text-field="name"
                                  style="width: 300px;display: inline-block;"
                                ></b-form-select>
                            </span>

                            <span >
                                <button :disabled="input_submit_disabled" v-on:click="onSubmit">Submit</button>
                                <button v-on:click="clear" style="color: green;">Clear</button>
                                <!--button :disabled="input_submit_disabled" v-on:click="refresh" style="color: red;">Refresh</button-->
                                <!--button v-on:click="add" style="color: black; font-weight: bold;">Add New Product</button-->
                            </span>

                        </b-col>
                    </b-row>
                </b-form>
                
            </div>

            <div>
                <vue-good-table
                  :columns="columns"
                  @on-cell-click="onColumnClick"
                  :rows="products"
                  :search-options="{
                    enabled: true,
                    trigger: 'enter'
                  }"
                  :pagination-options="{
                    enabled: true,
                    mode: 'pages',
                    position: 'top',
                    perPage: 50
                  }"
                  :select-options="{ enabled: false }"
                  styleClass="vgt-table bordered condensed"
                >   
                    <div slot="selected-row-actions">
                        <button>Disable Selected</button>
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'">
                            <span v-if="product_expanded[props.row.product_id] === true">
                                <b-button variant="outline-danger" size="sm"><b>Collapse</b></b-button>
                            </span>
                            <span v-else>
                                <b-button variant="outline-success" size="sm"><b>Expand</b></b-button>
                            </span>
                            <!-- <span>
                                <b-button variant="outline-success" size="sm"><b>Other</b></b-button>
                            </span> -->
                        </span>

                        <span v-if="props.column.field == 'inventory'">
                            <p>
                                <span v-for="item in props.row.inventory.location_aggregates">
                                    <b-button size="sm" :style="{'background-color': location_colors[item.id], 'border': '0px', margin: '5px', 'font-weight': 'bold'}">
                                        {{ item.name }} <b-badge variant="light"> {{ item.count }} </b-badge>
                                    </b-button>
                                </span>
                            </p>

                            <b-collapse v-model="product_expanded[props.row.product_id]" class="mt-2">
                                <b-table striped hover :small="true" :items="props.row.inventory.sublocation_aggregates" :fields="sublocation_inventory_columns"></b-table>
                            </b-collapse>


                            <!-- <span v-if="props.row.items['1'] < 5">
                                <b-input v-model="props.row.items['1']" class="yellow" type="number"></b-input>
                            </span>

                            <span v-else>
                                <b-input v-model="props.row.items['5']" class="normal" type="number"></b-input>
                            </span> -->
                        </span>

                        <!--span v-if="props.column.field == 'items.1'">
                            <span v-if="props.row.items['1'] < 5">
                                <b-input v-model="props.row.items['1']" class="yellow" type="number"></b-input>
                            </span>

                            <span v-else>
                                <b-input v-model="props.row.items['5']" class="normal" type="number"></b-input>
                            </span>
                        </span>
                        
                        <span v-else-if="props.column.field == 'items.2'">
                            <span v-if="props.row.items['2'] < 5">
                                <b-input v-model="props.row.items['2']" class="yellow" type="number"></b-input>
                            </span>

                            <span v-else>
                                <b-input v-model="props.row.items['2']" class="normal" type="number"></b-input>
                            </span>
                        </span>
                        
                        <span v-else-if="props.column.field == 'items.3'">
                            <span v-if="props.row.items['3'] < 5">
                                <b-input v-model="props.row.items['3']" class="yellow" type="number"></b-input>
                            </span>

                            <span v-else>
                                <b-input v-model="props.row.items['3']" class="normal" type="number"></b-input>
                            </span>
                        </span>
                       
                        <span v-else-if="props.column.field == 'items.4'">
                            <span v-if="props.row.items['4'] < 5">
                                <b-input v-model="props.row.items['4']" class="yellow" type="number"></b-input>
                            </span>

                            <span v-else>
                                <b-input v-model="props.row.items['4']" class="normal" type="number"></b-input>
                            </span>
                        </span>

                        <span v-else-if="props.column.field == 'items.5'">
                            <span v-if="props.row.items['5'] < 5">
                                <b-input v-model="props.row.items['5']" class="yellow" type="number"></b-input>
                            </span>

                            <span v-else>
                                <b-input v-model="props.row.items['5']" class="normal" type="number"></b-input>
                            </span>
                        </span

                        <!--span v-if="props.column.field == 'sku'">
                            <a v-bind:href="'/products/view/?value='+ props.row.sku+'&type=sku'" target="_blank">     {{props.row.sku}} 
                            </a>
                        </span-->

                        <span v-else>
                            {{props.formattedRow[props.column.field]}}
                        </span>
                    </template>
                </vue-good-table>
            </div>

            <!--b-modal id="modal-product" scrollable title="Product Data" size="lg" hide-footer>
                <Product :viewdata="product_data" :new="false" />
            </b-modal>


            <b-modal id="modal-new-product" scrollable title="Add New Product" size="lg" hide-footer>
                <Product :viewdata="product_data" :new="true" />
            </b-modal-->

        </div>
    </div>    
</template>


<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import Product from '@/components/importables/Product'
    
    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'


    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    export default {
        name: "ListProducts",
        components: {Backer, VueGoodTable, Multiselect, Product},
        data: function(){
            return {
                input_submit_disabled: false,
                search_by:  null,
                search_values: {},
                search_bys: [
                    {value: "sku", text: "SKU"},
                    {value: "location",  text: "Inventory Location"},
                    {value: "product_name", text: "Product Name"},
                    {value: "product_category", text: "Product Category"}
                ],
                categories: [],
                category_id: null,
                locations: [],
                location_colors: {},
                product_expanded: {},
                columns: [
                    {
                        label: "ID",
                        field: "product_id",
                        filterable: true,
                        sortable: true,
                    },
                    {
                        label: "SKU",
                        field: "sku",
                        filterable: true,
                        sortable: true,
                    },
                    {
                        label: "Product",
                        field: "product_name",
                        filterable: true,
                        sortable: false,
                    },
                    {
                        label: "Inventory",
                        field: "inventory",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                    {
                        label: "Total Count",
                        field: "total_count",
                        filterable: true,
                        sortable: true,
                    },
                    {
                        label: "Actions",
                        field: "actions",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    }
                ],
                products: [],
                sublocation_inventory_columns: [
                    {
                        key: "name",
                        label: "Sublocation",
                    },
                    {
                        key: "count",
                        label: "Available",
                    }
                ]
            }

        },
        methods: {
            // closeModal: function(e){
            //     e.preventDefault();
            //     this.$bvModal.hide("modal-product");
            //     this.onSubmit();
            //     //this.$bvModal.show("modal-product");
            // },
            onColumnClick: function(params){
                let row_data = params;
                let action = params.event.target.innerText;
                this.product_expanded = {};
                if (action === "Expand") {
                    this.product_expanded[row_data.row.product_id] = true;
                }
                else if (action === "Collapse") {
                    //this.product_expanded[row_data.row.product_id] = false;
                    this.product_expanded = {};
                }
                return
            },
            clear: function(e){
                e.preventDefault();
                this.search_by = null;
                this.search_values = {};
                this.products = [];
                this.product_expanded = {};
                return
            },
            fetch_prereqs: function(){
                let that = this;
                let obj = [
                    {
                        key: "columns", 
                        params: {},
                        path: "/api/inventory/get_inventory_list_columns/",
                        s: function(response){
                            if (response.data){
                                if (response.data.result.length > 0) {
                                    //that.columns = response.data.result;
                                }
                                else {
                                    console.log(response.data.error);
                                }
                            }
                        },
                        f: function(error){
                            console.log(error)
                        }
                    }, 
                    {
                        key: "categories", 
                        params: {},
                        path: "/api/product/category/all/",
                        s: function(response){
                            if (response.data){
                                if (response.data.result.length > 0) {
                                    that.categories = response.data.result.map(function(d){return {value: d[0], text: d[1]} });
                                }
                                else {
                                    console.log(response.data.error);
                                }
                            }
                        },
                        f: function(error){
                            console.log(error)
                        }
                    },
                    {
                        key: "locations", 
                        params: {},
                        path: "/api/location/list_locations/",
                        s: function(response){
                            if (response.data){
                                if (response.data.result.length > 0) {
                                    that.locations = response.data.result;
                                    that.location_colors = that.locations.reduce(function(map, obj) {
                                        map[obj.id] = (obj.properties.color || "#efefef");
                                        return map;
                                    }, {});
                                }
                                else {
                                    console.log(response.data.error);
                                }
                            }
                        },
                        f: function(error){
                            console.log(error)
                        }
                    },

                ];
                for (var i=0; i < obj.length; i++){
                    let item = obj[i];
                    Requestor.getAsyncP(item.path, item.params, this, item.s, item.f);
                }

            },
            refresh: function(e){
                e.preventDefault();
                this.onSubmit();
            },
            onSubmit: function(e, init_search){
                if (e){
                    e.preventDefault();    
                }

                let that = this;
                that.product_expanded = {};
                let search_key = this.search_by;
                let search_value = this.search_values[search_key];

                let path = "/api/inventory/lookup_inventory/";
                if (init_search){
                    path = "/api/inventory/lookup_inventory/all/";
                }
                
                let data = {search_key: search_key, search_value: search_value};

                let s = function(response){
                    that.input_submit_disabled = false;
                    if (response.data){
                        if (response.data.result){
                            that.products = response.data.result;
                            if (that.products.length == 0){
                                that.$bvToast.toast(
                                    "No results found.", 
                                    {title: "No Results", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                            return
                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error, 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                            return
                        }
                    }
                }

                let f = function(error){
                    that.input_submit_disabled = false;
                    that.$bvToast.toast(
                        error.response, 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                that.input_submit_disabled = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            add: function(e){
                e.preventDefault();
                this.product_data = {properties: {}};
                this.$bvModal.show("modal-new-product");
            },
            fetch_init: function(){
                //fetch all inventory
                this.onSubmit(null, true);
            }
        },
        created: function(){
            this.fetch_prereqs();
            this.fetch_init();
        }
    }
</script>

<style scoped>
    .yellow {
        color: black;
        background: #ffffe5;
        width: 70px;
    }

    .normal {
        color: black;
        background: white;
        width: 70px;
    }
</style>





// WEBPACK FOOTER //
// src/components/ListInventoryProducts.vue